// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Fn = (...args: any[]) => void;

/**
 * Function splitter for event handlers.
 *
 * @typeParam F - Function type (infered)
 *
 * @param fns Functions to split
 * @returns A function that calls all the provided functions with the same arguments
 *
 * @example
 * ```tsx
 * <Button
 * 	onClick={
 * 		splitEventHandler(
 * 			props.onClick,
 * 			(event) => {
 * 				// Do something else
 * 			}
 * 		)
 * 	}
 * >
 * 	Click me
 * </Button>
 * ```
 */
export const splitEventHandler =
	<F extends Fn>(...fns: Array<F | undefined>) =>
	(...args: Parameters<F>) =>
		fns.forEach((fn) => fn?.(...args));
